<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4 mb-5" style="max-width:560px">
        <h3>Synkroniser produkter</h3>

        <div v-show="!loading">
            <div v-if="locations.length === 0" class="mt-4">
              <span class="message-info">Ingen avdelinger har Tripletex aktivert. Aktiver det under Avdelinger.</span>
            </div>

            <div v-else-if="!configured" class="mt-4">
              <span class="message-info">Tripletex-konto er ikke konfigurert for denne avdelingen. Gå til <a href="/tripletex">Tripletex innstillinger</a> for å sette opp.</span>
            </div>

            <div v-if="configured">
                <div v-if="hasMultiLocations()" class="mt-4">
                  <span class="ingredient-title">Velg avdeling</span>
                  <select class="form-select" v-model="locationId" @change="onLocationChange()">
                    <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
                  </select>
                </div>

                <div class="mt-4">
                  <p class="text-muted">Synkroniser menyartikler til Tripletex produktkatalog. Ikke nødvendig for restauranter — fakturaordrer bruker fritekstlinjer med navn, pris og MVA. Relevant for retail, grossist og catering med faste pakker.</p>
                  <button type="button" class="bo_btn mt-2" @click="syncProducts"> Synkroniser produkter </button>

                  <div v-if="syncCompleted" class="mt-3 mb-5">
                    <div :class="syncResult.success ? 'message-success' : 'message-error'">
                      <p>{{ syncResult.message }}</p>
                      <p v-if="syncResult.createdCount !== undefined">Opprettet: {{ syncResult.createdCount }} | Oppdatert: {{ syncResult.updatedCount }} | Feil: {{ syncResult.errorCount }}</p>
                    </div>
                    <div v-if="syncResult.errors" class="mt-2">
                      <span class="ingredient-title">Feildetaljer:</span>
                      <ul>
                        <li v-for="(error, index) in syncResult.errors" :key="index">{{ error }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SettingsService from "@/services/settings/SettingsService";
  import LocationUtil from "@/util/LocationUtil";
  import LocationService from "@/services/location/LocationService";

  export default {
    components: {LoadingSpinner},
    data() {
      return {
        loading: true,
        locationId: '',
        locations: [],
        configured: false,
        syncCompleted: false,
        syncResult: {}
      };
    },
    mounted() {
      LocationService.listLocations().then(
          (response) => {
            this.locations = response.data.filter(l => l.accountingSystem === 'TRIPLETEX');
            this.locationId = this.locations.length ? this.locations[0].id : '';

            if (this.locationId) {
              this.checkSyncStatus();
            } else {
              this.configured = false;
              this.loading = false;
            }
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      onLocationChange(){
        this.syncCompleted = false;
        this.checkSyncStatus();
      },
      checkSyncStatus(){
        SettingsService.getTripletexSyncStatus(this.locationId).then(
            (response) => {
              if(response.data !== null){
                this.configured = response.data.configured;
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      },
      syncProducts(){
        this.loading = true;
        this.syncCompleted = false;

        SettingsService.syncProductsToTripletex(this.locationId).then(
            (response) => {
              this.syncCompleted = true;
              this.syncResult = response.data;
              this.loading = false;
            },
            (error) => {
              this.syncCompleted = true;
              this.syncResult = { success: false, message: 'Feil ved produktsynkronisering' };
              console.log(error);
              this.loading = false;
            }
        );
      }
    }
  };
</script>
